<template>
  <label class="switch" :class="{ 'checked': value }">
    <input type="checkbox" v-model="checked" @change="onChange">
    <span class="slider" :class="{ 'checked': value }"></span>
  </label>
</template>

<script>
export default {
  name: 'SwitchInput',

  props: {
    value: Boolean,
  },

  data() {
    return {
      checkedProxy: false
    }
  },

  computed: {
    checked: {
      get() {
        return this.value
      },
      set(value) {
        this.checkedProxy = value
      }
    }
  },

  methods: {
    onChange: function(e) {
      this.$emit('input', this.checkedProxy)
    }
  }
}
</script>

<style scoped>
.switch {
  display: flex;
  width: 46px;
  height: 20px;
  background-color: #ccc;
  border-radius: 15px;
  cursor: pointer;
  transition: .4s;
}

.switch input {
  display: none;
}

.slider {
  height: 16px;
  width: 16px;
  background-color: white;
  border-radius: 50%;
  margin: 2px;
  transition: .4s;
}

.switch.checked {
  background-color: #0084FF;
}

.slider.checked {
  transform: translateX(26px);
}
</style>
